import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import TopNavbar from "../components/Nav/TopNavbar";
import Contact from "../components/Sections/Footer";
import Footer from '../components/Sections/Footer'
const Layout = () => {
  return (
    <>
      <TopNavbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default Layout;
